// Sandbox
export const HOST_API = process.env.REACT_APP_HOST_API_KEY || 'https://gc.digitalfd.net/api';
export const GOCARDLESS_URL = process.env.REACT_APP_GOCARDLESS_URL || 'https://manage-sandbox.gocardless.com';

export const QUICKBOOKS_URL = GOCARDLESS_URL.includes('sandbox') 
    ? 'https://app.sandbox.qbo.intuit.com'
    : 'https://app.qbo.intuit.com';

